import { render, staticRenderFns } from "./MatrizBase.vue?vue&type=template&id=011dc17c&"
import script from "./MatrizBase.vue?vue&type=script&lang=ts&"
export * from "./MatrizBase.vue?vue&type=script&lang=ts&"
import style0 from "./MatrizBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('011dc17c', component.options)
    } else {
      api.reload('011dc17c', component.options)
    }
    module.hot.accept("./MatrizBase.vue?vue&type=template&id=011dc17c&", function () {
      api.rerender('011dc17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MatrizProducto/MatrizBase.vue"
export default component.exports